module.exports = __webpack_public_path__ + "assets/img/dating.66ab6d7e.svg";